$(document).ready(function () {
    // console.log(window.$breakpoints);
    // SLICK SLIDER =============
    $('[data-slick]').each(function () {
        var $is_responsive = $(this).data('responsive') === true;
        var $is_mobile_only = $(this).data('slick-mobile') === true;

        const $slick_args = {};
        $data_slick = $(this).data('slick');
        // console.log("is_mobile_only = " + $is_mobile_only);
        if ($is_mobile_only) {

            $default_slick_mobile = {
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                draggable: true,
                responsive: [
                    {
                        breakpoint: parseInt($breakpoints.md) - 1,
                        settings: 'unslick'
                    }
                ]
            };

            $.extend($slick_args, $default_slick_mobile, $data_slick);

            // console.log($slick_args);
            $(this).slick($slick_args);


        } else {
            // console.log("is_responsive = " + $is_responsive);
            if (!$is_responsive) {
                // console.log($data_slick);
                $(this).slick($data_slick);
            } else {

                $default_slick = {
                    dots: true,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    responsive: [
                        {
                            breakpoint: parseInt($breakpoints.lg), // lg
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                                infinite: true,
                                dots: true
                            }
                        },
                        {
                            breakpoint: parseInt($breakpoints.md), // md
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: parseInt($breakpoints.sm), // sm
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                        // You can unslick at a given breakpoint now by adding:
                        // settings: "unslick"
                        // instead of a settings object
                    ]
                };

                $.extend($slick_args, $default_slick, $data_slick);

                // console.log($slick_args);
                $(this).slick($slick_args);
            }
        }

    });
    // /Init Slick sliders ====================================================
});